import { render, staticRenderFns } from "./ArtMinigame.vue?vue&type=template&id=09e38be0&scoped=true"
import script from "./ArtMinigame.vue?vue&type=script&lang=js"
export * from "./ArtMinigame.vue?vue&type=script&lang=js"
import style0 from "./ArtMinigame.vue?vue&type=style&index=0&id=09e38be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e38be0",
  null
  
)

export default component.exports